import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { useIsFetching } from "@tanstack/react-query";
import { AnimatePresence, motion } from "motion/react";
import useHideOnScroll from "../../hooks/useHideOnScroll";
import SCSpinner from "../loaders/SCSpinner";
import ThemeToggle from "../ui/ThemeToggle";
import logo from "../../assets/logo-nobg.png";

export default function Header() {
  const hidden = useHideOnScroll();
  const isFetching = useIsFetching();

  return (
    <header
      className={`sticky top-0 z-30 border-b border-mono/5 bg-surface/90 backdrop-blur-md transition-transform duration-300 ${
        hidden ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-3">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Smart Connect Electrical" className="h-9 w-auto" />
          <span className="font-serif text-base tracking-wide text-ink">
            Smart{" "}
            <span className="bg-gradient-to-br from-gold-300 via-gold-500 to-gold-600 bg-clip-text text-transparent">
              Connect
            </span>
          </span>
        </Link>

        <div className="flex items-center gap-1">
          {/* Reads as "something is loading" anywhere data is being fetched,
              without every page having to wire its own indicator. */}
          <AnimatePresence>
            {isFetching > 0 && (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2 }}
              >
                <SCSpinner size={22} showMark={false} />
              </motion.div>
            )}
          </AnimatePresence>
          <Link
            to="/search"
            aria-label="Search"
            className="rounded-full p-2 text-ink transition-colors hover:bg-mono/5"
          >
            <Search size={20} strokeWidth={1.8} />
          </Link>
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
